import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';
import { Text } from '../../../../components';

// The finish-payment modal reuses the "Pay to activate" modal's visual language
// (header cluster, payment options, total row) by importing its styled parts from
// `../PaymentModal/PaymentModal.styles`. Only the settle-specific bits live here.

/** Status line inside the card drawer while the invoice's Stripe intent is being
 *  prepared, or when it can't be (the invoice has no payable card intent yet). Amber,
 *  matching the wallet-short note, so an unavailable card path reads as advisory rather
 *  than an error — the wallet path is always there as the reliable alternative. */
export const CardStatusNote = styled(Text)`
  display: block;
  padding: 0 8px 12px;
  font-size: 12px;
  line-height: 1.35;
  color: ${COLORS.warning};
`;

/** The pending-invoice reassurance under the CTA. */
export const Footnote = styled(Text)`
  font-size: 13px;
  line-height: 1.25;
  text-align: center;
  color: ${COLORS.textBrightest};
`;
